// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-views[data-v-27f89001] {\n    opacity: 0.5;\n}\n.btn-views-active[data-v-27f89001] {\n    opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
